"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@csod/assets/assets/normalize.css");
require("@csod/assets/assets/csod-icons.css");
require("@csod/assets/assets/csod-style-utilities.css");
require("player-theming/theme.css");
var utils_1 = require("player-core/utils");
exports.default = {
    createUUID: utils_1.createUUID
};
//# sourceMappingURL=__exports.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/node_modules/@csod/dropdown-list/build/__exports.js
// module id = 584
// module chunks = 0